import { render, staticRenderFns } from "./imgecourse.vue?vue&type=template&id=61510ac4&scoped=true"
import script from "./imgecourse.vue?vue&type=script&lang=js"
export * from "./imgecourse.vue?vue&type=script&lang=js"
import style0 from "./imgecourse.vue?vue&type=style&index=0&id=61510ac4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61510ac4",
  null
  
)

export default component.exports